import React, { useState, useEffect } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import localization from 'assets/localization/localization';
import { DatePickerInput } from 'rc-datepicker';
import { FormGroup } from 'react-bootstrap';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const FdFilterForm = ({ applyFilter, status = []}) => {
  const [filterFieldsData, setFilterFieldsData] = useState({});
  
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        // console.log(filterFieldsData);
        applyFilter(filterFieldsData);
        filterFieldsData &&
          localStorage.setItem('applyFilter', JSON.stringify(filterFieldsData));
      }}
    >
      <ConstantInput
          label={localization.freshdeskId}
          value={filterFieldsData.freshdesk_id}
          regex={Regex.text.test(filterFieldsData.freshdesk_id)}
          type="number"
          handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, freshdesk_id: val })
          }
      />

      <DropDownInput
        label={localization.priority}
        data={[
            { id: 1, name: 'Low' },
            { id: 2, name: 'Medium' },
            { id: 3, name: 'High' },
            { id: 4, name: 'Urgent' }
          ]}
        getValueById={filterFieldsData?.priority}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, priority: val.id })
        }
      />

      <DropDownInput
        label={localization.status}
        data={[
            { id: 2, name: 'Open' },
            { id: 3, name: 'Pending' },
            { id: 4, name: 'Resolved' },
            { id: 5, name: 'Closed' }
          ]}
        getValueById={filterFieldsData?.status}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, status: val.id })
        }
      />

      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            localStorage.setItem('applyFilter', JSON.stringify({}));
            applyFilter({});
            localStorage.setItem('statusFilter', JSON.stringify({}));
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default FdFilterForm;
